let Backbone = require("backbone");

let main = function (Backbone) {
    return Backbone.Model.extend({
        defaults: {
            type: "Payment",
            method: "CASH",
            original: 0,
            amount: 0
        }
    });
};

let exportedValue = main(Backbone);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/model/PaymentModel.js